module.exports = __webpack_public_path__ + "static/media/wheels_back_tire_depth_picture.895258ec.png";